/**
 *
 * Asynchronously loads the component for Insights
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Insights = lazyLoad(
  () => import('./index'),
  module => module.Insights,
);
